import { DateSelectArg, EventClickArg } from '@fullcalendar/core/index.js';
import { useState } from 'react';
import { trpc } from '@/lib/trpc/trpc';
import DayView from './components/DayView';
import LargeLoadingArea from '../loadings/largeLoading';
import AddCalendarBooking from './components/components/addCalendarBooking';
import AddCalendarEvent from './components/components/addCalendarEvent';
import EditCalendarBooking from './components/components/editCalendarBooking';
import EditCalendarEvent from './components/components/editCalendarEvent';

export default function BookingCalendar() {
  const [showAddBooking, setShowAddBooking] = useState<boolean>(false);
  const [showEditBooking, setShowEditBooking] = useState<boolean>(false);
  const [showAddEvent, setShowAddEvent] = useState<boolean>(false);
  const [showEditEvent, setShowEditEvent] = useState<boolean>(false);
  const [dateSelected, setDateSelected] = useState<DateSelectArg>();
  const [eventSelected, setEventSelected] = useState<EventClickArg>();

  const getCalendarBookings = trpc.Booking.GetCalendarEvents.useQuery();

  const calendarOnSelect = (selected: DateSelectArg) => {
    setDateSelected(selected);
    if (selected.allDay) {
      setShowAddEvent(true);
      return;
    }
    setShowAddBooking(true);
  };

  const calendarOnClick = (event: EventClickArg) => {
    setEventSelected(event);
    if (event.event.allDay) {
      setShowEditEvent(true);
      return;
    }
    setShowEditBooking(true);
  };

  return (
    <div>
      {getCalendarBookings.data ? (
        <div>
          <DayView
            events={getCalendarBookings.data}
            calendarOnSelect={calendarOnSelect}
            onClick={calendarOnClick}
          />
          <AddCalendarBooking
            setShow={setShowAddBooking}
            show={showAddBooking}
            dateSelected={dateSelected}
          />
          <EditCalendarBooking
            setShow={setShowEditBooking}
            show={showEditBooking}
            eventSelected={eventSelected}
          />
          <AddCalendarEvent
            setShow={setShowAddEvent}
            show={showAddEvent}
            dateSelected={dateSelected}
          />
          <EditCalendarEvent
            setShow={setShowEditEvent}
            show={showEditEvent}
            eventSelected={eventSelected}
          />
        </div>
      ) : getCalendarBookings.isLoading ? (
        <LargeLoadingArea />
      ) : (
        <>
          <p>Error Loading Data...</p>
          <p>{getCalendarBookings.error?.message}</p>
        </>
      )}
    </div>
  );
}
